import config from "config/config.js";

const socialLogin = (objectToSend, updateNetworkFailed) => {
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Credentials": true,
      "Access-Control-Allow-Headers": true,
      "Access-Control-Allow-Methods": ["POST"],
      "Access-Control-Allow-Origin": `${config.baseUrl}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include",

    body: JSON.stringify(objectToSend)
  };
  const endpoint = `${config.baseUrl}/api/social/login`;
  return fetch(endpoint, options)
    .then(response => {
      if (response.status !== 200) {
        return null;
      }
      return response.json();
    })
    .then(response => {
      // eslint-disable-next-line no-console
      if (!response) {
        return null;
      }

      const result = {
        status: "ok",
        success: true,
        accessToken: response.accessToken,
        xsrfToken: response.xsrfToken
      };
      return result;
    })
    .catch(e => {
      if (e.message === "Network request failed") {
        updateNetworkFailed(true);
      }
    });
};
export default socialLogin;



// WEBPACK FOOTER //
// ./src/utils/socialLogin.js